"use client";

import { DiscountPreviewContext } from "@/components/discount/discount-preview-drawer/discount-preview-context";

import { PictureUpload } from "@/components/common/picture-upload/picture-upload";
import { Tilt } from "@/components/motion-primitives/tilt";
import { Button } from "@/components/ui/button";
import { createPath } from "@/service/routing/routing";
import { TicketPercentIcon } from "lucide-react";
import { useContext } from "react";
import { cn } from "@/lib/utils";

import { useProgress } from "@bprogress/react";
import { ActiveToTimer } from "../../common/active-to-timer";
import { SmallSquareVendorLogo } from "@/components/common/small-square-vendor-logo";

export const DiscountVerticalCard = ({
  product,
  small = false,
}: {
  product: DiscountPreviewVM;
  small?: boolean;
}) => {
  const context = useContext(DiscountPreviewContext);
  // const { setIsOpen, setDiscount, canShowPreview } = context || {};
  // const progress = useProgress();

  const { image, title, badge, slug, vendor } = product;
  const description = product?.valueText || "";
  const activeTo = product?.activeTo || null;

  return (
    <Tilt
      rotationFactor={4}
      isRevese
      className={cn(
        "group h-full rounded-xl transition-all",
        small ? "" : "hover:scale-101",
      )}
    >
      <a
        href={"/klubmedyka" + createPath("discount.show", { slug })}
        // onClick={(event) => {
        //   if (canShowPreview) {
        //     event.preventDefault();
        //     event.stopPropagation();
        //     setIsOpen(true);
        //     setDiscount(product);
        //     progress.stop();
        //   }
        // }}
        className={cn("flex h-full cursor-pointer flex-col")}
      >
        <div className="group relative flex-1 overflow-hidden rounded-xl border border-b-0">
          <div className="bg-club-lime absolute top-4 right-4 z-10 rounded-full px-2.5 py-0.5 text-sm font-semibold text-zinc-900">
            {badge}
          </div>
          <div className="aspect-[1.91 / 1] relative w-full overflow-hidden">
            <PictureUpload
              image={image.horizontal}
              className="w-full"
              aspectRatio={"1.91 / 1"}
              type={"card"}
            />
          </div>
          <div className="p-4">
            <div className={cn("flex h-[24px] items-center justify-between")}>
              <SmallSquareVendorLogo withoutLink={true} vendor={vendor} />

              {activeTo && <ActiveToTimer activeTo={activeTo} />}
            </div>
            <h3 className="mt-3.5 mb-1.5 font-semibold">{title}</h3>
            {!small && (
              <p
                dangerouslySetInnerHTML={{ __html: description }}
                className="text-muted-foreground line-clamp-4 text-[13px] [&>span]:font-bold"
              />
            )}
          </div>
        </div>
        {!small && (
          <div className="relative">
            <div
              className="absolute top-0 left-2 mx-auto w-[calc(100%-1rem)]"
              style={{
                borderTop: "1px dashed transparent",
                borderImage:
                  "repeating-linear-gradient(to right, #71717A 0, #71717A 6px, transparent 0, transparent 12px) 1",
              }}
            />
            <Button
              variant="outline"
              className={"mt-[1px] w-full rounded-xl border-t-0"}
            >
              <TicketPercentIcon className="h-4 w-4" />
              Wykorzystaj
            </Button>
          </div>
        )}
      </a>
    </Tilt>
  );
};
